module.exports = __webpack_public_path__ + "media/images/Pintrist_Transparent-284cc5d4b56bc29cc5caf91db2eb8dff.png";